import { PaymentType as ConfigPaymentType } from '@/models/app-config/behavior/types'
import { Order } from '@spa/store/modules/orderHistory/types'

export type PaymentType = ConfigPaymentType | 'none'

export interface PaymentTypeFactory {
  create(): PaymentType
}

export class StorePaymentTypeFactory implements PaymentTypeFactory {
  constructor(
    private readonly order: Order
  ) {}

  create(): PaymentType {
    return this.order.payment.method.kind
  }
}

export function paymentTypeIsExternalPayment(paymentType: PaymentType): boolean {
  const externalPaymentList: PaymentType[] = [
    'carrier',
    'webmoney',
    'creditcard3d',
  ]

  return externalPaymentList.some(p => p === paymentType)
}
